export default function BoxLabelItem() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "black",
      }}
    />
  );
}
